import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { ReviewSummary } from "@prisma/client";
import  PropertyReviewsSummary  from "./PropertyReviewsSummary";
import  PropertyReviewsList  from "./PropertyReviewsList";

interface ReviewDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  summary: ReviewSummary;
  reviews: any[];
}

export default function ReviewDetailsModal({
  isOpen,
  onClose,
  summary,
  reviews,
}: ReviewDetailsModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>All Reviews</DialogTitle>
        </DialogHeader>
        <div className="space-y-6">
          <PropertyReviewsSummary summary={summary} />
          <PropertyReviewsList reviews={reviews} showAll />
        </div>
      </DialogContent>
    </Dialog>
  );
} 